import { useMemo } from 'react';
import CheckboxDropdown from 'components/elements/MultiSelect';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { METROPOLITAN_CODE_TO_LABEL } from 'utils/constants/location';

type Props = {
  value: string[];
  onChangeSelection: (arg0: string[]) => void;
};

const LocationFilter = ({ value, onChangeSelection }: Props) => {
  const { availableRegions } = useAvailableCities();

  const regionOptions = useMemo(() => {
    return Object.keys(availableRegions).map((key: string) => ({
      key,
      label: METROPOLITAN_CODE_TO_LABEL[key] || key,
    }));
  }, [availableRegions]);

  return (
    <CheckboxDropdown
      selectedKeys={value}
      label="Location"
      options={regionOptions}
      onChangeSelection={onChangeSelection}
      placeholder="All"
      forceOutline
    />
  );
};

export default LocationFilter;
